// Shared email format check. Extracted from ProSourceForm.validateEmail so
// forms and helpers use the same rule.
const EMAIL_PATTERN =
  /^(([^À-ž<>()[\]\\.,;:+-\s@!?#$%^&'*/={}`~|"]+([\.\+\-][^À-ž<>()[\]\\.,;:+-\s@!?#$%^&'*/={}`~|"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isValidEmail = (email) =>
  EMAIL_PATTERN.test(String(email).toLowerCase());
